import { Component } from '@angular/core';

@Component({
    selector: 'app-spinner-overlay',
    templateUrl: 'src/app/utils/shared-services/spinner/spinner.html',
    standalone: false
})
export class SpinnerComponent {
  constructor() {}
}